export const WINDOW_SIZES = {
  MOBILE: 'SM',
  TABLET: 'M',
  DESKTOP: 'LG',
};
